/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState, useEffect, useCallback } from 'react';

import { useHistory } from 'react-router';
import { ExitSessionConfirmationModal } from '../../ParticipantRoom/ExitSessionConfirmationModal/ExitSessionConfirmationModal';
import { get } from '@utils/lodash';

export interface EnsureAuthWrapperProps {
  children?: React.ReactNode;
  ensureAuthenticated: (pathname: string) => Promise<void>;
}

const errorMessages = (status: number): string => {
  const msg: { [key: number]: string } = {
    // 400: 'Room not available', TODO: RON-330
    404: 'Not found',
    500: 'Internal Server Error',
  };

  if (!msg[status]) {
    return 'Unknown error occurred';
  }
  return msg[status];
};

export const EnsureAuthWrapper: React.SFC<EnsureAuthWrapperProps> = ({ ensureAuthenticated, children }) => {
  const history = useHistory();
  const [error, setError] = useState<{ status: number; msg: string } | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const ensureAuth = useCallback(async () => {
    try {
      await ensureAuthenticated(get(history, 'location.pathname'));
      setIsAuthenticated(true);
    } catch (e) {
      const status = get(e, 'response.status');
      setError({ status, msg: errorMessages(status) });
    }
  }, [get(history, 'location.pathname')]);
  useEffect(() => {
    ensureAuth();
  }, []);

  if (error) {
    return (
      <div>
        <h1>Something went wrong</h1>
        <p>
          {error.status} {error.msg}
        </p>
        <ExitSessionConfirmationModal />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }
  return <>{children}</>;
};
